import MobileDetect from 'mobile-detect';
export { default as launchApplicationMarket } from './launchApplicationMarket';
export { default as file } from './file';
export function randomUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function dataGroupingToJson(array, key) {
  if (!key) return array;
  var aMap = [];
  var oResult = {};
  for (var i = 0; i < array.length; i++) {
    var item = array[i];
    if (aMap.indexOf(item[key]) === -1) {
      oResult[item[key]] = [item.areaNo];
      aMap.push(item[key]);
    } else {
      oResult[item[key]].push(item.areaNo);
    }
  }
  return oResult;
}

// 国际化对象取值
export function parseObjectValue(values, outKey = '') {
  if (!values) {
    return values;
  }
  if (values instanceof Array) {
    const newOutKey = `${outKey}`;
    return values.map((value, index) => parseObjectValue(value, `${newOutKey}[${index}]`)).flat();
  }
  if (typeof values === 'object') {
    const vals = JSON.parse(JSON.stringify(values));
    const newOutKey = `${outKey}${outKey && '.'}`;
    return Object.keys(vals)
      .map((key) => parseObjectValue(vals[key], `${newOutKey}${key}`))
      .flat();
  }
  if (/[a-zA-Z]+(-[a-zA-Z]+)+/.test(values)) return null;
  if (typeof values === 'number') return null;
  return `${outKey}${outKey && ': '}${values}`;
}

// _命名转换成驼峰
export function underlineToHump(values) {
  if (!values) {
    return values;
  }
  if (values instanceof Array) {
    return values.map((value) => underlineToHump(value));
  }
  if (typeof values === 'object') {
    const vals = JSON.parse(JSON.stringify(values));
    const oldNames = Object.keys(vals);
    const newNames = Object.keys(vals).map((name) => name.replace(/(_[a-z])/g, (match) => match.toUpperCase().replace('_', '')));
    oldNames.forEach((newName) => {
      vals[newName] = underlineToHump(vals[newName]);
    });
    newNames.forEach((newName, i) => {
      const name = Object.keys(vals)[i];
      vals[newName] = underlineToHump(vals[name]);
    });
    return vals;
  }
  return values;
}
// 驼峰转_
export function humpToUnderline(values) {
  if (!values) {
    return values;
  }
  if (values instanceof Array) {
    return values.map((value) => humpToUnderline(value));
  }
  if (typeof values === 'object') {
    const vals = JSON.parse(JSON.stringify(values));
    const oldNames = Object.keys(vals);
    const newNames = Object.keys(vals).map((name) => name.replace(/([A-Z])/g, (match) => `_${match.toLowerCase()}`).replace(/^_/, ''));

    oldNames.forEach((newName) => {
      vals[newName] = humpToUnderline(vals[newName]);
    });
    newNames.forEach((newName, i) => {
      const name = Object.keys(vals)[i];
      vals[newName] = humpToUnderline(vals[name]);
    });
    return vals;
  }
  return values;
}

// 截取url上的商品sku参数
export function sliceSku(value = '') {
  return (/goodsSKu=\w+/.exec(value)[0] || '').split('=')[1];
}

export function parseQuery(url = '') {
  const query = {};
  try {
    const queryStr = url.split('?')[1] || '';
    const queryArr = queryStr.split('&').map((item) => item.split('='));
    if (queryArr.length === 0 || !queryArr[0]) {
      return query;
    }
    queryArr.forEach(([name, value]) => {
      query[name] = value;
    });
    return query;
  } catch (error) {
    return query;
  }
}

// 订单倒计时
export function countDownOrder(endSeconds = [0], callback) {
  let newEndSeconds = typeof endSeconds === 'number' ? [endSeconds] : endSeconds;
  newEndSeconds = newEndSeconds.map((secondTime) => ({ secondTime }));

  const execCountDown = () => {
    newEndSeconds = newEndSeconds.map(({ secondTime }) => {
      const newSecondTime = secondTime - (secondTime > 0 ? 1 : 0);
      let day = `0${parseInt(newSecondTime / 86400, 10)}`;
      let hours = `0${parseInt((newSecondTime % 86400) / 3600, 10)}`;
      let minutes = `0${parseInt(((newSecondTime % 86400) % 3600) / 60, 10)}`;
      let seconds = `0${parseInt(((newSecondTime % 86400) % 3600) % 60, 10)}`;
      day = day.slice(day.length - 2);
      hours = hours.slice(hours.length - 2);
      minutes = minutes.slice(minutes.length - 2);
      seconds = seconds.slice(seconds.length - 2);
      const formatStr = `${day > 0 ? day : ''}${hours}:${minutes}:${seconds}`;
      return {
        secondTime: newSecondTime,
        day,
        hours,
        minutes,
        seconds,
        formatStr,
      };
    });

    if (callback) {
      callback(newEndSeconds);
    }
  };
  execCountDown();
  const timeInterval = setInterval(execCountDown, 1000);
  return timeInterval;
}

function urlToImg(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.addEventListener('load', () => resolve(img));
    img.crossOrigin = 'Anonymous';
    img.src = url;
  });
}

function blobToImg(blob) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const img = new Image();
      img.addEventListener('load', () => resolve(img));
      img.crossOrigin = 'Anonymous';
      img.src = reader.result;
    });
    reader.readAsDataURL(blob);
  });
}

function imgToCanvas(img, img2) {
  const canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  const context = canvas.getContext('2d');
  context.drawImage(img, 0, 0);
  if (canvas.width > canvas.height) {
    context.drawImage(img2, 0, 0, canvas.width, canvas.width);
  } else {
    context.drawImage(img2, 0, 0, canvas.height, canvas.height);
  }

  return canvas;
}

function watermark(canvas) {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob));
  });
}

function base64ToFile(dataurl, filename = 'image.png') {
  if (!dataurl) {
    return '';
  }
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime,
  });
}

async function getImage(image) {
  if (typeof image === 'string') {
    return await urlToImg(image);
  } else {
    return await blobToImg(image);
  }
}

const blobToBase64 = async (blob, fileName) => {
  const reader = await new FileReader(); // 实例化一个reader文件
  await reader.readAsDataURL(blob); // 添加二进制文件
  return new Promise((resolve) => {
    reader.onload = async (event) => {
      const base64 = await event.target.result; // 获取到它的base64文件
      const scale = 0.5; // 设置缩放比例 （0-1）
      let file = await compressImg(base64, scale, fileName);
      resolve(file);
    };
  });
};
// 压缩大小
const compressImg = (base64, scale, fileName) => {
  // 处理缩放，转换格式
  // 用canvas来压缩
  const img = new Image();
  img.src = base64;
  return new Promise((resolve) => {
    img.onload = async () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.setAttribute('width', img.width * scale);
      canvas.setAttribute('height', img.height * scale);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      // 转成base64 文件
      base64 = canvas.toDataURL('image/jpeg', 0.8); //0到1之间的取值，主要用来选定图片的质量，默认值是0.92，超出范围也会选择默认值
      const arr = base64.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bytes = atob(arr[1]);
      const bytesLength = bytes.length;
      const u8arr = new Uint8Array(bytesLength);
      for (let i = 0; i < bytes.length; i++) {
        u8arr[i] = bytes.charCodeAt(i);
      }
      const file = await new File([u8arr], fileName, { type: mime });
      resolve(file);
    };
  });
};

// 图片加水印
/**
 *
 * @param {File | String} image 图片文件或图片url地址
 * @param {String} text 水印文字
 * @param {String} font 字体属性
 * @param {String} fillStyle 字体颜色
 * @param {Number} rotate 旋转角度
 */
export async function addWaterMark(image, image2) {
  // 压缩图片,大于500kb就压缩
  let imgFile = null;
  if (image.size / 1024 > 300) {
    imgFile = await blobToBase64(image, image.name);
  } else {
    imgFile = image;
  }
  console.log(imgFile);

  let [img, img2] = await Promise.all([getImage(imgFile), getImage(image2)]);
  let canvas = imgToCanvas(img, img2);
  let blob = await watermark(canvas);
  let newImg = await blobToImg(blob);
  let src = newImg.src;
  let newFile = base64ToFile(src, 'image.png');
  let newUrl = window.URL.createObjectURL(newFile);
  console.log(newFile);
  return {
    newFile,
    src,
    newUrl,
  };
}

// 最近时间
export function formatNearTime(timestamp, $t) {
  if (!timestamp) return '';
  const ONE_MINUTE = 60 * 1000;
  const ONE_HOUR = 60 * ONE_MINUTE;
  const ONE_DAY = 24 * ONE_HOUR;
  const WEEK_DAY = 7 * ONE_DAY;

  const nowDate = new Date();
  const date = new Date(timestamp * 1);

  const diffTimestamp = nowDate.getTime() - date.getTime();
  if (diffTimestamp < ONE_MINUTE) {
    return $t('cfmoto.justNow');
  } else if (diffTimestamp >= ONE_MINUTE && diffTimestamp < ONE_HOUR) {
    var res = Math.floor(diffTimestamp / ONE_MINUTE);
    return $t('cfmoto.minAgo').replace('%s', res);
  }
  if (diffTimestamp >= ONE_HOUR && diffTimestamp < ONE_DAY) {
    const res = Math.floor(diffTimestamp / ONE_HOUR);
    return $t('cfmoto.hoursAgo').replace('%s', res);
  }
  if (diffTimestamp >= ONE_DAY && diffTimestamp < WEEK_DAY) {
    const res = Math.floor(diffTimestamp / ONE_DAY);
    return $t('cfmoto.daysAgo').replace('%s', res);
  }
  const year = date.getFullYear();
  const month = (date.getMonth() + 1 + '').padStart(2, '0');
  const day = (date.getDate() + '').padStart(2, '0');
  if (nowDate.getFullYear() === date.getFullYear()) {
    return `${month}-${day}`;
  }
  return `${year}-${month}-${day}`;
}

// 版本号比较
export function compareVersions(v1, v2) {
  if (!v1 && !v2) return 0;
  if (!v1) return -1;
  if (v1 && !v2) return 1;
  const parts1 = v1.split(/[.-]/);
  const parts2 = v2.split(/[.-]/);

  const len = Math.max(parts1.length, parts2.length);

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(parts1[i] || 0, 10);
    const num2 = parseInt(parts2[i] || 0, 10);

    if (num1 > num2) return 1;
    if (num1 < num2) return -1;
  }

  return 0;
}

export function getCustomAgent() {
  if (!window.navigator.customAgent) {
    // window.navigator.customAgent = 'Mozilla/5.0 (iPhone; CPU iPhone OS 18_1_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 cfmoto/2.1.3 (iPhone 11 Build/18.1.1)';
    window.navigator.customAgent = window.navigator.userAgent;
  }
  const userAgent = window.navigator.customAgent;
  // const userAgent = window.navigator.userAgent;
  const md = new MobileDetect(userAgent);

  // const appType = this.isAndroid ? 'Android' : 'IOS';
  const appVersion = (/(cfmoto|Cfmoto)\/([\d]+\.[\d]+\.[\d]+)/.exec(userAgent) || [])[2];
  const systemVersionStr = md.versionStr(md.os()) || md.versionStr('Android') || md.versionStr('iOS');
  const systemVersion = `${md.os()} ${systemVersionStr}`.replace(/_/g, '.').split(' ')[1];
  const phoneModel = (/\(([^\\(]+) (Build\/[\\.\d]+\))/.exec(userAgent) || [])[1] || 'unknown';
  // const phoneModel = ((/(Mobile\/[\w]+)/.exec(userAgent) || [])[1] || 'Build/unknown').replace('Mobile', `Build`);
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const screenSize = `${screenWidth}*${screenHeight}`;
  console.log(md);
  console.log(phoneModel, systemVersion);

  console.log(window.navigator.userAgent); // 'Sony'
  console.log(md.mobile()); // 'Sony'
  console.log(md.phone()); // 'Sony'
  console.log(md.mobileGrade()); // 'Sony'
  console.log(md.tablet()); // null
  console.log(md.userAgent()); // 'Safari'
  console.log(md.os()); // 'AndroidOS'
  console.log(md.is('iPhone')); // false
  console.log(md.is('iPhone')); // false
  console.log(md.version('Webkit')); // 534.3
  console.log(md.versionStr(md.os()) || md.versionStr('Android') || md.versionStr('iOS')); // '4.1.A.0.562'
  console.log(md.match('playstation|xbox')); // false
  console.log('==== appVersion ====');
  console.log((/(cfmoto|Cfmoto)\/([\d]+\.[\d]+\.[\d]+)/.exec(userAgent) || [])[2]);
  console.log('==== model ====');
  console.log((/\(([^\\(]+) (Build\/[\\.\d]+\))/.exec(userAgent) || [])[1] || 'unknown');

  if (/ios/.test((md.os() || '').toLocaleLowerCase())) {
    return `MOBILE|${md.os()}|${systemVersion}|CFMOTO_INTERNATIONAL_APP|${appVersion}|iPhone|iPhone|${screenSize}|${randomUUID().toUpperCase()}`;
  }
  // Mozilla/5.0 (iPhone; CPU iPhone OS 18_1_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 cfmoto/2.1.3 (iPhone 11 Build/18.1.1)
  // return 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/92.0.4515.131 Safari/537.36';
  // MOBILE|Android|7.1.1|KLICEN_APP|4.0.10|Dalvik/2.1.0 (Linux; U; Android 7.1.1; OD103 Build/NMF26F)|1080*1920|ccf8ba18defca0f6|100
  return `MOBILE|Android|${systemVersion}|CFMOTO_INTERNATIONAL_APP|${appVersion}|Dalvik/2.1.0 (Linux; U; Android ${systemVersion}; OD103 Build/${phoneModel})|${screenSize}|${randomUUID()}|100`;
}
